import { render, staticRenderFns } from "./AreaTab.vue?vue&type=template&id=67fa0f2f"
import script from "./AreaTab.js?vue&type=script&lang=js&external"
export * from "./AreaTab.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports